export default __webpack_public_path__ + "static/bubble-0e79d902aec422b9f5911235962d85ed.png";